export default "__VITE_ASSET__DFLCNzjC__"